import React, { useMemo } from 'react'
import Price from '../models/Price'
import { Tax } from '../models/Tax'
import { Vis } from 'models/Vis'
import { useInitIdioma } from 'customHooks/useInitIdioma'
import { PriceItem } from './PriceItem'

interface Props {
    prices: Price[]
    money: any
    tax: Tax
    visitas: Vis
    quitarVisitantePrices(event: any): void
    addVisitantePrices(event: any): void
    limiteCapacidad?: boolean
    publicToken: any
    isCollaboratorStretch?: boolean
    passengerCategories?: any
    minimumPassengerReach?: any
}

export const PricesView = (
  {
      prices,
      money,
      tax,
      visitas,
      quitarVisitantePrices,
      addVisitantePrices,
      limiteCapacidad,
      publicToken,
      isCollaboratorStretch,
      minimumPassengerReach,
  }: Props) => {
    const { t } = useInitIdioma(publicToken)


    const pasajerosTotal = useMemo(() => {
        return visitas.vis?.length > 0
          ? visitas.vis.reduce((acc, curr) => acc + curr, 0)
          : 0
    }, [visitas.vis])

    if (!prices || prices.length === 0) return null
    return (
      <>
          <h3 className="preciosHeading">{t('prices')}</h3>

          {prices.map((precio, index) => (
            <PriceItem
              key={precio.id}
              precio={precio}
              index={index}
              tax={tax}
              visitas={visitas}
              money={money}
              isCollaboratorStretch={isCollaboratorStretch}
              minimumPassengerReach={minimumPassengerReach}
              quitarVisitantePrices={quitarVisitantePrices}
              addVisitantePrices={addVisitantePrices}
              t={t}
            />
          ))}

          {limiteCapacidad && (
            <div className="opciones" style={{ color: 'red' }}>
                {t('maximumNumber')} {pasajerosTotal}
            </div>
          )}
      </>
    )
}
